import { Entity, Viewer } from "cesium";
import { createContext, useContext, createSignal, onCleanup } from "solid-js";

// Define the context type
type StateContextType = {
  isGuestbookOpen: () => boolean;
  toggleGuestbook: () => void;
  isChatboxOpen: () => boolean;
  toggleChatbox: () => void;
  isNavOpen: () => boolean;
  toggleIsNavOpen: () => void;
  setIsNavOpen: (isOpen: boolean) => void;
  isSmallViewport: () => boolean;
  cViewer: () => Viewer|null;
  setViewer: (viewer: Viewer | null) => void;
  selectedEntity: () => Entity | null;
  setSelectedEntity: (entity: Entity | null) => void;
  messages: () => { role: string, content: string }[];
  setMessages: (messages: { role: string, content: string }[]) => void;
  userMessages: () => { role: string, content: string }[];
  setUserMessages: (userMessages: { role: string, content: string }[]) => void;
};

// Create the context
const StateContext = createContext<StateContextType>();

// Provide the context
export const StateContextProvider = (props: any) => {
  const [isGuestbookOpen, setIsGuestbookOpen] = createSignal(false);
  const [isChatboxOpen, setIsChatboxOpen] = createSignal(false);
  const [isNavOpen, setIsNavOpen] = createSignal(false);
  const [isSmallViewport, setIsSmallViewport] = createSignal(
      window.matchMedia("(max-width: 35em)").matches
  );
  const [cViewer, setViewer] = createSignal<Viewer|null>(null);
  const [selectedEntity, setSelectedEntity] = createSignal<Entity|null>(null);

  const toggleGuestbook = () => {
      setIsGuestbookOpen(!isGuestbookOpen());
  };
  const toggleChatbox = () => {
      setIsChatboxOpen(!isChatboxOpen());
  };
  const toggleIsNavOpen = () => {
      setIsNavOpen(!isNavOpen());
  }

  const mediaQuery = window.matchMedia("(max-width: 35em)");
  const updateViewportState = (e: MediaQueryListEvent) => { setIsSmallViewport(e.matches); };
  mediaQuery.addEventListener("change", updateViewportState);
  onCleanup(() => {
    mediaQuery.removeEventListener("change", updateViewportState);
  });
  const [messages, setMessages] = createSignal(
        [{ role: 'system', content: "Your job is to make Josh Hussey sound like a good person to hire. Don't lay it on too thick, but be generous. Keep it casual but professional. And if and only if they ask, you love the Edmonton Oilers." }]
    );
  const [userMessages, setUserMessages] = createSignal([] as { role: string, content: string }[]);

  return (
    <StateContext.Provider value={{ isGuestbookOpen, toggleGuestbook, isChatboxOpen, toggleChatbox, isNavOpen, toggleIsNavOpen, setIsNavOpen, isSmallViewport, cViewer, setViewer, selectedEntity, setSelectedEntity, messages, setMessages, userMessages, setUserMessages }}>
      {props.children}
    </StateContext.Provider>
  );
};

// Custom hook to use the Guestbook context
export const useStateContext = () => {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error("useContext must be used within a StateContextProvider");
  }
  return context;
};

